module.exports = "pegasus_template/assets/blocks/column-17-theme2.png";